import { Message } from "semantic-ui-react";

function ErrorPage(props) {
  const { error } = props;

  return (
    <div className="page-wrap">
      <Message error header="Application error">
        {error.message}
      </Message>
    </div>
  );
}

export default ErrorPage;
